import { render, staticRenderFns } from "./UniversityExamUpdateScore.vue?vue&type=template&id=d711de2c&scoped=true"
import script from "./UniversityExamUpdateScore.vue?vue&type=script&lang=js"
export * from "./UniversityExamUpdateScore.vue?vue&type=script&lang=js"
import style0 from "./UniversityExamUpdateScore.vue?vue&type=style&index=0&id=d711de2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d711de2c",
  null
  
)

export default component.exports